module.exports = __webpack_public_path__ + "static/img/fun4.43dd24d5.png";